import { useNavigate } from "react-router-dom";
import { useReviewStore } from "../../../hooks/useReviewStore";
import { exploreClasses } from "../../../mocks/explore";

const STAGE_LABELS = ["1일차 복습", "3일차 복습", "7일차 복습"];
const STAGE_COLORS = ["#FF8C00", "#E91E63", "#00D873"];

function DueCard({ item, onReviewed }: { item: ReturnType<typeof useReviewStore>["dueToday"][0]; onReviewed: () => void }) {
  const navigate = useNavigate();
  const cls = exploreClasses.find((c) => c.id === item.classId);
  const stageLabel = STAGE_LABELS[item.stage] ?? "최종 복습";
  const stageColor = STAGE_COLORS[item.stage] ?? "#00D873";

  return (
    <div className="flex items-center gap-3 p-4 bg-[#FFF9F0] rounded-2xl border border-[#FFE0B2]">
      <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: cls?.iconBg ?? "#F2F4F6" }}>
        <i className={`${cls?.icon ?? "ri-book-line"} text-lg`} style={{ color: cls?.iconColor ?? "#8B95A1" }} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[10px] font-extrabold px-2 py-0.5 rounded-full" style={{ backgroundColor: `${stageColor}20`, color: stageColor }}>
            {stageLabel}
          </span>
        </div>
        <p className="text-sm font-extrabold text-[#191F28] truncate">{item.classTitle}</p>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        <button
          onClick={() => navigate(`/learn/${item.classId}`)}
          className="text-[11px] font-bold text-[#8B95A1] border border-[#E4E6EA] px-3 py-1.5 rounded-full cursor-pointer hover:border-[#00D873] hover:text-[#00D873] transition-all whitespace-nowrap"
        >
          복습하기
        </button>
        <button
          onClick={onReviewed}
          className="text-[11px] font-extrabold text-white px-3 py-1.5 rounded-full cursor-pointer whitespace-nowrap"
          style={{ backgroundColor: stageColor }}
        >
          ✓ 완료
        </button>
      </div>
    </div>
  );
}

export default function ReviewCycleSection() {
  const { dueToday, upcomingItems, markReviewed } = useReviewStore();

  if (dueToday.length === 0 && upcomingItems.length === 0) return null;

  return (
    <div className="bg-white rounded-3xl p-7">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-xl font-black text-[#191F28]">오늘의 복습</h3>
          <p className="text-xs text-[#8B95A1] mt-0.5">망각 곡선에 맞춰 최적 복습 타이밍이에요</p>
        </div>
        {dueToday.length > 0 && (
          <span className="text-xs font-extrabold bg-[#FF8C00]/10 text-[#FF8C00] px-3 py-1.5 rounded-full">
            오늘 {dueToday.length}개 추천
          </span>
        )}
      </div>

      {dueToday.length > 0 ? (
        <div className="space-y-2.5 mb-5">
          {dueToday.map((item) => (
            <DueCard key={item.classId} item={item} onReviewed={() => markReviewed(item.classId)} />
          ))}
        </div>
      ) : (
        <div className="bg-[#E8F5E9] rounded-2xl p-5 flex items-center gap-4 mb-5">
          <div className="text-3xl">🎉</div>
          <div>
            <p className="text-sm font-extrabold text-[#00D873]">오늘은 복습 없는 날!</p>
            <p className="text-xs text-[#8B95A1] mt-0.5">다음 복습이 예정되어 있어요</p>
          </div>
        </div>
      )}

      {/* Upcoming reviews */}
      {upcomingItems.length > 0 && (
        <div>
          <p className="text-xs font-extrabold text-[#8B95A1] mb-3">예정된 복습</p>
          <div className="space-y-2">
            {upcomingItems.slice(0, 3).map((item) => {
              const daysLeft = Math.ceil((item.nextReviewMs - Date.now()) / (24 * 60 * 60 * 1000));
              const stageColor = STAGE_COLORS[item.stage] ?? "#00D873";
              return (
                <div key={item.classId} className="flex items-center gap-3 px-4 py-3 bg-[#F9F9F9] rounded-xl">
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-bold text-[#191F28] truncate">{item.classTitle}</p>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-[10px] font-extrabold px-2 py-0.5 rounded-full" style={{ backgroundColor: `${stageColor}15`, color: stageColor }}>
                      {STAGE_LABELS[item.stage]}
                    </span>
                    <span className="text-[11px] font-bold text-[#8B95A1]">D-{daysLeft}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
